import { render, staticRenderFns } from "./relocationAllowence.vue?vue&type=template&id=7fa513b8&scoped=true"
import script from "./relocationAllowence.vue?vue&type=script&lang=js"
export * from "./relocationAllowence.vue?vue&type=script&lang=js"
import style0 from "./relocationAllowence.vue?vue&type=style&index=0&id=7fa513b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa513b8",
  null
  
)

export default component.exports